import prescriptionUpload from "@custom/rtk-apis/patients/prescriptionUpload";
import { createSlice } from "@reduxjs/toolkit";
// import patientList from "../../../rtk-apis/patients/patientList";
const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const prescriptionUploadSlice = createSlice({
  name: "prescriptionUploadSlice",
  initialState,
  reducers: {
    closePrescriptionModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(prescriptionUpload.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(prescriptionUpload.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(prescriptionUpload.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default prescriptionUploadSlice.reducer;
export const { closePrescriptionModal } = prescriptionUploadSlice.actions;
